export default __webpack_public_path__ + "static/c64manual-24de632ee90ae3a751e14803367df207.pdf";